module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-centerhorizontal-f3769117472f6fa8d1e234d9307411af.svg";